import { render, staticRenderFns } from "./selectEjercicio.vue?vue&type=template&id=1dc445d5&scoped=true"
import script from "./selectEjercicio.vue?vue&type=script&lang=js"
export * from "./selectEjercicio.vue?vue&type=script&lang=js"
import style0 from "./selectEjercicio.vue?vue&type=style&index=0&id=1dc445d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc445d5",
  null
  
)

export default component.exports